import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import ErrorMessage from "ui/molecules/Errors/ErrorMessage";

const NoClubErrorPage = () => {
  return (
    <ErrorMessage
      pageTitle="No club found"
      pageHeading="No club found"
      pageCopy="Looks like you don’t have a club linked to your account. Something not right? Give us a shout."
    >
      <Button
        onClick={() => {
          window.location.href = `mailto:support@manvfat.com`;
        }}
        variant="primary"
        color="primary"
      >
        Contact The Dugout Support
        <ButtonArrow />
      </Button>
    </ErrorMessage>
  );
};

export default NoClubErrorPage;
